<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<HomeScroll />
			<LayoutHero :items="items" />
			<LayoutPattern :items="items" />
			<LayoutNews :items="items" :blog="blog" />
			<LayoutRSS :blog="blog" />
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import HomeScroll from "./components/HomeScroll.vue";
import LayoutHero from "./components/LayoutHero.vue";
import LayoutPattern from "./components/LayoutPattern.vue";
import LayoutNews from "./components/LayoutNews.vue";
import LayoutRSS from "./components/LayoutRSS.vue";
import BaseLoading from "@/components/items/BaseLoading.vue";

import Meta from "@/mixins/MetaSettable";
import Hash from "@/mixins/AnchorLink";
import Preview from "@/mixins/Preview";

export default {
	mixins: [Meta, Hash, Preview],

	props: ["animation", "blog"],

	components: {
		HomeScroll,
		LayoutHero,
		LayoutPattern,
		LayoutNews,
		LayoutRSS,
		BaseLoading,
	},

	data() {
		return {
			items: [],
			pageActive: false,
			loading: true,
		};
	},

	mounted() {
		if(this.$route.query.mode == 'preview') {
			this.axios.get('/preview/top_page', {
				headers: {
					Authorization: `Bearer ${this.$cookies.get('preview-token')}`,
				}
			}).then((response) => {
				this.items = response.data.response;
				this.loading = false;
				this.pageActive = true;
			}).catch(() => {
				this.loading = false;
				this.pageActive = true;
			});
		}else{
			this.axios.get('/top_page').then((response) => {
				this.items = response.data.response;
				this.loading = false;
				this.pageActive = true;
			}).catch(() => {
				this.loading = false;
				this.pageActive = true;
			});
		}
	},
};
</script>

<style lang="scss"></style>
